// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"c25cfefe","767":"44b08dbd","826":"95d7817f","853":"95d7817f","872":"95d7817f","952":"40144998"}[chunkId] + ".css";
};